import React, { useEffect, useState } from 'react';
import DateSelector from '../components/dumb/form/DateSelector';

function LeadFilterForm(props) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [leadStage, setLeadStage] = useState('');
    const [startDate, setStartDate] = useState(1633060315);
    const [assignedTo, setAssignedTo] = useState('');
    const [targetBatch, setTargetBatch] = useState('');

    useEffect(() => {
        props.changeFilter(name, email, phoneNo, leadStage, assignedTo, startDate, targetBatch);
    }, [name, email, phoneNo, leadStage, assignedTo, startDate, targetBatch])

    return (
        <div>
            <div className="form-group">
                <label>Name</label>
                <input
                    type="text"
                    className="form-control"
                    id="name"
                    onChange={(e) => setName(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Email</label>
                <input
                    type="text"
                    className="form-control"
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Phone No</label>
                <input
                    type="text"
                    className="form-control"
                    id="phoneNo"
                    onChange={(e) => setPhoneNo(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Lead Stage</label>
                <input
                    type="text"
                    className="form-control"
                    id="leadStage"
                    onChange={(e) => setLeadStage(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label> Target Batch </label>
                <input
                  type="text"
                  className={"form-control"}
                  id={"leadStage"}
                  onChange={(e) => setTargetBatch(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Assigned To</label>
                <input
                    type="text"
                    className="form-control"
                    id="assignedTo"
                    onChange={(e) => setAssignedTo(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label> Start Date </label>
                <DateSelector
                    selectDate={date => setStartDate(date)}
                />
            </div>
        </div>
    )
}

export default LeadFilterForm;
